// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"b32c589c","4499":"508d2014"}[chunkId] + ".chunk.css";
};